import { MPSItem, NavigateOptions } from "../types";
import { calculateVATForPrice } from "./Calculation";

const centsToRand = (cents: number): string => {
  return (cents / 100).toFixed(2);
};

export const numberWithSpaces = (x: string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const setNavigateOptions = (tryAgain: boolean, path: string, header: string, message: string): NavigateOptions => {
  return {
    tryAgain,
    path,
    error: {
      header,
      message,
    },
  };
};

const padTo2Digits = (num: number): string => {
  return num.toString().padStart(2, "0");
};

const formatDate = (): string => {
  const date = new Date();
  const yyMMdd = `${date.getFullYear()}${padTo2Digits(date.getMonth() + 1)}${padTo2Digits(date.getDate())}`;
  const hhMMss = `${padTo2Digits(date.getHours())}${padTo2Digits(date.getMinutes())}${padTo2Digits(date.getSeconds())}`;
  return `${hhMMss}-${yyMMdd}`;
};

export const getDefaultInvoiceNumber = (companyName: string): string => {
  const tradingNameAbbreviation = companyName.toUpperCase().substring(0, 3);
  const placeholder = `iK${tradingNameAbbreviation}${formatDate()}`;
  return placeholder;
};

/***
 * @param date
 * @returns {string}
 * @description This function takes in a ISO date string and returns a formatted date string
 * in the format of "DD MMM YYYY"
 * @example
 * formatDatev2('2021-01-01T00:00:00.000Z') // returns "1 Jan 2021"
 **/
export const formatDatev2 = (date: string): string => {
  const inputDate = new Date(date).toLocaleString("en-ZA", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return inputDate;
};

export const isService = (item: MPSItem) => {
  return "category" in item && "duration" in item;
};

export const getDurationText = (duration = 0): string => {
  if (duration === 0) return "-";

  let time = "";
  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;
  if (hours > 0 && hours < 2) time += `${hours} hr`;
  if (hours > 1) time += `${hours} hrs`;
  if (hours >= 1 && minutes > 0) time += " ";
  if (minutes > 0) time += `${minutes} mins`;
  return time;
};

export const getVatAmountForMPSLineItem = (lineItem: MPSItem): number => {
  return lineItem.vat ? calculateVATForPrice(lineItem.price) * lineItem.quantity : 0;
};

export const getTotalAmountForMPSLineItem = (lineItem: MPSItem): number => {
  return Number(lineItem.price) * Number(lineItem.quantity);
};

export const getTotalAmountForMPSLineItemArray = (lineItemInformationArray: MPSItem[]): number => {
  return lineItemInformationArray
    ? lineItemInformationArray.reduce((acc, obj) => Number(acc) + getTotalAmountForMPSLineItem(obj), 0)
    : 0;
};

const processLine = (acc: number, obj: MPSItem): number => {
  return Number(acc) + getVatAmountForMPSLineItem(obj);
};

export const getTotalVatAmountForMPSLineItemArray = (lineItemInformationArray: MPSItem[]): number => {
  return lineItemInformationArray ? lineItemInformationArray.reduce((acc, obj) => processLine(acc, obj), 0) : 0;
};

export default centsToRand;
